import React, { ReactElement } from 'react';

import { create } from 'jss';
//eslint-disable-next-line no-restricted-imports
import createTheme from '@material-ui/core/styles/createTheme';
// eslint-disable-next-line
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
  jssPreset
} from '@material-ui/core/styles';
import { color, colorShades } from './color';
import layout from './layout';
import font from './font';
import mixin from './mixin';

import { BREAKPOINTS } from './breakponts';
import muiPickersOverrides from './mui-pickers-overrides';
import muiComponentsOverrides from './mui-components-overrides';
import { typography } from './typography';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    color: typeof color;
    colorShades: typeof colorShades;
  }
}

export const themeObject = {
  breakpoints: {
    values: BREAKPOINTS,
  },

  palette: {
    primary: {
      main: '#ffcd50',
    },
    secondary: {
      main: '#3a465a',
    },
    action: {
      disabledBackground: '#ffd77388',
    },
  },
  overrides: {
    ...muiPickersOverrides,
    ...muiComponentsOverrides,
  },
  color,
  colorShades,
  layout,
  font,
  mixin,
  typography,
  important: (propertyValue: any) => `${propertyValue}!important`,
  props: {
    MuiTypography: {
      variantMapping: {
        body1: 'div',
        body2: 'div',
      },
    },
  },
};

const theme = createTheme(themeObject);

interface Props {
  children: ReactElement;
}

const jss = create({
  ...jssPreset(),
  insertionPoint: 'v4-jss-insertion-point',
});

export const Theme = ({ children }: Props) => {
  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StylesProvider>
  );
};
